import React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useMyTrainingsDatatable } from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

import { AttendanceTag } from 'modules/trainings/components/MyTrainings/MyTrainingsDatatable/AttendanceTag'
import { NextSessionLabel } from 'modules/trainings/components/MyTrainings/MyTrainingsDatatable/NextSessionLabel'
import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

interface Props {
  accessId: number
  employeeId: number
  rowNavigation: (trainingId: string) => string
  children: React.ReactNode
  debouncedSearch: string
}
export const MyTrainingDatatableProvider = ({
  accessId,
  employeeId,
  rowNavigation,
  children,
  debouncedSearch,
}: Props) => {
  const { collectModalities } = useTrainingsDatatable()

  const source = useMyTrainingsDatatable(
    [
      {
        identifier: 'name',
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.my_training.all_courses_table.training'),
        render: ({ name }) => name,
        template: '{{ name }}',
      },
      {
        identifier: 'modality',
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.trainings_table.type'),
        render: ({ sessions }) => collectModalities(sessions),
        template: '',
      },
      {
        identifier: 'nextSession',
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.my_training.all_courses_table.next_session'),
        render: ({ sessions }) => <NextSessionLabel sessions={sessions} accessId={accessId} />,
        template: '',
      },
      {
        identifier: 'status',
        kind: ProjectionKind.Custom,
        title: i18n.t('trainings.reminders_table.status'),
        render: ({ id }) => {
          return <AttendanceTag trainingId={id} employeeId={employeeId} />
        },
        template: '',
      },
      {
        identifier: 'actions',
        kind: ProjectionKind.Decorative,
        render: ({ id }) => {
          return (
            <Box alignItems="flexEnd">
              <Button.Router
                type="secondary"
                to={rowNavigation(String(id))}
                iconName="arrow-right"
              />
            </Box>
          )
        },
      },
    ],
    {
      variables: {
        search: debouncedSearch,
        accessId: accessId,
        status: 'active',
      },
    }
  )

  return (
    <DataTable.Provider
      rowTo={({ id }) => rowNavigation(String(id))}
      source={source}
      sort={{ path: 'name', direction: 'asc' }}
    >
      {children}
    </DataTable.Provider>
  )
}
